// src/pages/auth/ForgotPassword.js
import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [msg, setMsg] = useState(null);

  async function submit(e) {
    e.preventDefault();
    setErr(null);
    setMsg(null);
    setBusy(true);

    try {
      await sendPasswordResetEmail(auth, email.trim(), {
        url: window.location.origin + "/login",
      });
      setSent(true);
      setMsg("Reset link sent. Check your email.");
    } catch (e) {
      console.error("Forgot password error:", e);
      setErr(e?.message || "Failed to send reset link");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ maxWidth: 360, margin: "10vh auto", fontFamily: "system-ui" }}>
      <h2>Reset password</h2>

      {sent ? (
        <>
          <div style={{ color: "seagreen", marginTop: 8 }}>
            {msg || "Check your email for a password reset link."}
          </div>

          <div style={{ marginTop: 12 }}>
            <Link to="/login" style={{ fontSize: 14 }}>
              Back to login
            </Link>
          </div>
        </>
      ) : (
        <>
          <form onSubmit={submit}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: "100%", padding: 8, margin: "8px 0" }}
              required
            />

            <button
              disabled={busy}
              type="submit"
              style={{ padding: "8px 12px" }}
            >
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>

          <div style={{ marginTop: 10 }}>
            <Link to="/login" style={{ fontSize: 14 }}>
              Back to login
            </Link>
          </div>

          {err && <div style={{ color: "crimson", marginTop: 8 }}>{err}</div>}
          {msg && <div style={{ color: "seagreen", marginTop: 8 }}>{msg}</div>}
        </>
      )}
    </div>
  );
}
